/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IInterestRateModel,
  IInterestRateModelInterface,
} from "../IInterestRateModel";

const _abi = [
  {
    inputs: [],
    name: "DP",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCompoundInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "ri",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "Tcrit",
        type: "int256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCompoundInterestRateWithOverflowDetection",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "ri",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "Tcrit",
        type: "int256",
      },
      {
        internalType: "bool",
        name: "overflow",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_c",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "_totalDeposits",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalBorrowAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_interestRateTimestamp",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "calculateCurrentInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcur",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCompoundInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCompoundInterestRateAndUpdate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcomp",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getConfig",
    outputs: [
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "getCurrentInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "rcur",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interestRateModelPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_blockTimestamp",
        type: "uint256",
      },
    ],
    name: "overflowDetected",
    outputs: [
      {
        internalType: "bool",
        name: "overflow",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        components: [
          {
            internalType: "int256",
            name: "uopt",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ucrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ulow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ki",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "kcrit",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klow",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "klin",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "beta",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "ri",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "Tcrit",
            type: "int256",
          },
        ],
        internalType: "struct IInterestRateModel.Config",
        name: "_config",
        type: "tuple",
      },
    ],
    name: "setConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IInterestRateModel__factory {
  static readonly abi = _abi;
  static createInterface(): IInterestRateModelInterface {
    return new utils.Interface(_abi) as IInterestRateModelInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IInterestRateModel {
    return new Contract(address, _abi, signerOrProvider) as IInterestRateModel;
  }
}
